import styled from 'styled-components';

import { colors, body2, caption, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

import { StyledWrapper } from './../InputStyles';

import { TextAreaProps } from './TextArea.types';

export const StyledTextArea = styled.textarea<
  Omit<TextAreaProps, 'onChange'> & { autoGrowMinHeight?: number | string }
>`
  ${body2};
  background-color: transparent;
  box-shadow: none; /** overrides global CSS on type="text" */
  box-sizing: border-box;
  border: none;
  display: block;
  flex: 1 1 auto;
  ${({ autoGrowMinHeight }) => (autoGrowMinHeight ? 'grid-area: 1 / 1 / 2 / 2;' : '')}
  outline: 0;
  ${({ autoGrowMinHeight }) => (autoGrowMinHeight ? 'overflow: hidden;' : '')}
  padding: ${spacing.half} ${spacing.threeQuarter};
  resize: ${({ autoGrowMinHeight, resize }) => (autoGrowMinHeight ? 'none' : resize || 'none')};
  width: 100%;

  ::placeholder {
    color: ${colors.textSecondary};
  }
  :active {
    border: none;
  }
  :focus {
    &::placeholder {
      color: ${colors.textDisabled};
    }
  }
`;

export const StyledTextAreaGrowWrap = styled.div<{ autoGrowMinHeight: number | string }>`
  display: grid; /** stack elements */
  min-height: ${({ autoGrowMinHeight }) =>
    typeof autoGrowMinHeight === 'string' ? autoGrowMinHeight : pxToRem(autoGrowMinHeight)};
  width: 100%;

  ::after {
    content: attr(data-replicated-value) ' '; /** space to prevent jumpy behavior */
    grid-area: 1 / 1 / 2 / 2; /** place on top of each other */
    white-space: pre-wrap; /** mimic text behavior in textarea */
    visibility: hidden; /** hide from view, clicks, and screen readers */
  }
`;

export const StyledTextAreaWrapper = styled(StyledWrapper)`
  padding: 0;

  ${({ $hasWrapperStyling }) =>
    $hasWrapperStyling &&
    `
      align-items: flex-start;
      && {
        height: auto;
      }

      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    `}
`;

export const CharacterCount = styled.div`
  ${caption}
  text-align: right;
  color: ${colors.textDisabled};
`;
